/* Registry of dashboard message namespaces. Each namespace has one file per language in ./locales/<lang>/. */
import en_common from "./locales/en/common";
import en_nav from "./locales/en/nav";
import en_ai from "./locales/en/ai";
import en_languages from "./locales/en/languages";
import en_ui from "./locales/en/ui";
import en_auth from "./locales/en/auth";
import en_account from "./locales/en/account";
import en_overview from "./locales/en/overview";
import en_builder from "./locales/en/builder";
import en_catalog from "./locales/en/catalog";
import en_orders from "./locales/en/orders";
import en_marketing from "./locales/en/marketing";
import en_settings from "./locales/en/settings";
import en_admin from "./locales/en/admin";
import en_credits from "./locales/en/credits";
import en_studio from "./locales/en/studio";
import en_call from "./locales/en/call";
import en_aiadmin from "./locales/en/aiadmin";
import en_voicelab from "./locales/en/voicelab";
import fr_common from "./locales/fr/common";
import fr_nav from "./locales/fr/nav";
import fr_ai from "./locales/fr/ai";
import fr_languages from "./locales/fr/languages";
import fr_ui from "./locales/fr/ui";
import fr_auth from "./locales/fr/auth";
import fr_account from "./locales/fr/account";
import fr_overview from "./locales/fr/overview";
import fr_builder from "./locales/fr/builder";
import fr_catalog from "./locales/fr/catalog";
import fr_orders from "./locales/fr/orders";
import fr_marketing from "./locales/fr/marketing";
import fr_settings from "./locales/fr/settings";
import fr_admin from "./locales/fr/admin";
import fr_credits from "./locales/fr/credits";
import fr_studio from "./locales/fr/studio";
import fr_call from "./locales/fr/call";
import fr_aiadmin from "./locales/fr/aiadmin";
import fr_voicelab from "./locales/fr/voicelab";
import ar_common from "./locales/ar/common";
import ar_nav from "./locales/ar/nav";
import ar_ai from "./locales/ar/ai";
import ar_languages from "./locales/ar/languages";
import ar_ui from "./locales/ar/ui";
import ar_auth from "./locales/ar/auth";
import ar_account from "./locales/ar/account";
import ar_overview from "./locales/ar/overview";
import ar_builder from "./locales/ar/builder";
import ar_catalog from "./locales/ar/catalog";
import ar_orders from "./locales/ar/orders";
import ar_marketing from "./locales/ar/marketing";
import ar_settings from "./locales/ar/settings";
import ar_admin from "./locales/ar/admin";
import ar_credits from "./locales/ar/credits";
import ar_studio from "./locales/ar/studio";
import ar_call from "./locales/ar/call";
import ar_aiadmin from "./locales/ar/aiadmin";
import ar_voicelab from "./locales/ar/voicelab";

const en = {
  common: en_common,
  nav: en_nav,
  ai: en_ai,
  languages: en_languages,
  ui: en_ui,
  auth: en_auth,
  account: en_account,
  overview: en_overview,
  builder: en_builder,
  catalog: en_catalog,
  orders: en_orders,
  marketing: en_marketing,
  settings: en_settings,
  admin: en_admin,
  credits: en_credits,
  studio: en_studio,
  call: en_call,
  aiadmin: en_aiadmin,
  voicelab: en_voicelab,
};
const fr = {
  common: fr_common,
  nav: fr_nav,
  ai: fr_ai,
  languages: fr_languages,
  ui: fr_ui,
  auth: fr_auth,
  account: fr_account,
  overview: fr_overview,
  builder: fr_builder,
  catalog: fr_catalog,
  orders: fr_orders,
  marketing: fr_marketing,
  settings: fr_settings,
  admin: fr_admin,
  credits: fr_credits,
  studio: fr_studio,
  call: fr_call,
  aiadmin: fr_aiadmin,
  voicelab: fr_voicelab,
};
const ar = {
  common: ar_common,
  nav: ar_nav,
  ai: ar_ai,
  languages: ar_languages,
  ui: ar_ui,
  auth: ar_auth,
  account: ar_account,
  overview: ar_overview,
  builder: ar_builder,
  catalog: ar_catalog,
  orders: ar_orders,
  marketing: ar_marketing,
  settings: ar_settings,
  admin: ar_admin,
  credits: ar_credits,
  studio: ar_studio,
  call: ar_call,
  aiadmin: ar_aiadmin,
  voicelab: ar_voicelab,
};

export const MESSAGES = { en, fr, ar };

type En = typeof en;
/** Every valid translation key, e.g. "nav.products". Typos fail the typecheck. */
export type MessageKey = { [NS in keyof En]: `${NS & string}.${keyof En[NS] & string}` }[keyof En];
